import {
  FormLabel,
  Radio,
  type RadioProps,
  RadioGroup,
  FormControl,
  FormControlLabel,
  type RadioGroupProps,
  type FormLabelProps,
  type FormControlLabelProps,
} from "@mui/material";

import { Option } from "api/common/types/common.types";
import { useFieldContext } from "components/Forms/AppForm";
import ErrorMessage from "components/Forms/components/helpers/ErrorMessage";

interface RadioButtonProps {
  options: Option[];
  label: string;
  isHorizontal?: boolean;
  disabled?: boolean;
  required?: boolean;
  slots?: {
    FormLabel?: Partial<FormLabelProps>;
    Radio?: Partial<RadioProps>;
    RadioGroup?: Partial<RadioGroupProps>;
    RadioLabel?: Partial<FormControlLabelProps>;
  };
}

const RadioButton = ({
  options = [],
  label,
  isHorizontal = false,
  disabled = false,
  required = false,
  slots,
}: RadioButtonProps) => {
  const field = useFieldContext<string>();

  return (
    <FormControl>
      <FormLabel
        id={`${label}-radio-buttons-group-label`}
        color="primary"
        required={required}
        {...slots?.FormLabel}
      >
        {label}
      </FormLabel>
      <RadioGroup
        aria-labelledby={`${label}-radio-buttons-group-label`}
        value={field.state.value}
        name={`${label}-radio-buttons-group`}
        onChange={(e) => field.handleChange(e.target.value)}
        row={isHorizontal}
        {...slots?.RadioGroup}
      >
        {options.map((option) => (
          <FormControlLabel
            {...slots?.RadioLabel}
            control={<Radio {...slots?.Radio} />}
            key={option.value}
            value={option.value}
            disabled={disabled}
            label={option.label}
            sx={{ mt: 2 }}
          />
        ))}
      </RadioGroup>
      <ErrorMessage />
    </FormControl>
  );
};
export default RadioButton;
